import React from "react";

const AspectRatioBox = ({
  style = {},
  ratio = 100,
  children,
  hidden = true,
}) => {
  return (
    <div
      style={{
        overflow: hidden ? "hidden" : "visible",
        paddingTop: ratio + "%",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          ...style,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default AspectRatioBox;
